import Table from "./table/table";
import { WebSocketManager } from "../../helpers/webSocketManager";
import router from "../../../../routes";

import userServices from "@/services/user-services";
import TournamentTable from "./table/tournamentTable";
// import localScaleM/anager from "../../helpers/LocalScaleManager";

export default class TableGame {
  constructor(scene, tableNumber, id) {
    this.tableNumber = tableNumber;
    this.scene = scene;
    this.tableId = id;
    this.tableClubId = null;
    this.tableInfo = {};
    this.tableWallet = {};
    this.table = null;
  }

  async init() {
    // this.test = this.scene.add
    //   .image(0, 0, "test")
    //   .setOrigin(0)
    //   .setAlpha(0.5)
    //   .setDepth(20);
    // this.test.setVisible(false);
    return new Promise((resolve, reject) => {
      userServices
        .get(`tables/${this.tableId}/table-info`)
        .then((res) => {
          this.tableInfo = res.body.data;
          if (this.tableInfo.deleted) {
            this.scene.expiredTables.push(this.tableInfo);
          }
          userServices
            .get(`wallets/get-wallet-by-table/${this.tableId}`)
            .then((res) => {
              this.tableWallet = res.body.data;
              // this.tableInfo.isTournament = true;
              if (this.tableInfo.isTournament) {
                this.table = new TournamentTable(
                  this.scene,
                  this.tableNumber,
                  this.tableInfo,
                  this.tableWallet
                );
              } else {
                this.table = new Table(
                  this.scene,
                  this.tableNumber,
                  this.tableInfo,
                  this.tableWallet
                );
              }

              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject();
            });
        })
        .catch((e) => {
          console.error(e);
          reject();
        });
    });
  }
  async getTableInfo() {
    return new Promise((resolve, reject) => {
      userServices
        .get(`tables/${this.tableId}/table-info`)
        .then((res) => {
          this.tableInfo = res.body.data;
          this.table.tableInfo = this.tableInfo;
          resolve();
        })
        .catch((e) => {
          console.error(e);
          reject();
        });
    });
  }
  handleGameState(state) {
    this.table.handleGameState(state);
  }

  /**
   * When we want to receive game states
   */
  observeTable() {
    WebSocketManager.emitEvent(
      {
        tableId: this.tableId,
        clubId: this.scene.getURLClubId(),
      },
      "poker.client-push.observe"
    )
      .then()
      .catch((e) => {
        console.error(e);
      });
  }
  /**
   * When we want to not receive game states
   */
  async observeNotTable() {
    return new Promise((resolve, reject) => {
      WebSocketManager.emitEvent(
        { tableId: this.tableId },
        "poker.client-push.observe-not"
      )
        .then(() => resolve())
        .catch((e) => {
          console.error(e);
          reject();
        });
    });
  }
  changeTableTo(newTableId) {
    // console.log("changeTableTo");
    this.tableId = newTableId;
    this.table.completeTweens();
    this.table.setIdle();
    this.table.unseatSelfPlayer().finally(() => {
      this.table.gameState = {};
      this.table.firstGameState = null;
      this.getTableInfo();
      // this.observeTable();
      router
        .replace(`/game/${newTableId}/${this.scene.getURLClubId()}`)
        .catch((err) => {});
    });
  }
  /**
   * It's called when swipe to the table
   */
  async visitTable() {
    return new Promise((resolve, reject) => {
      userServices
        .post(`tables/visit-table`, {
          tableId: this.tableId,
          clubId: this.scene.getURLClubId(),
        })
        .then((res) => {
          const visitingData = res.body.data;
          this.tableClubId = visitingData.clubId;
          if (visitingData.deleted) {
            this.scene.tableExpired(this.tableId);
            reject("Table has been deleted.");
          } else {
            resolve();
          }
        })
        .catch((e) => {
          console.error(e);
          reject(e);
        });
      // WebSocketManager.emitEvent(
      //   {
      //     tableId: this.tableId,
      //     clubId: this.scene.getURLClubId(),
      //   },
      //   "poker.client-push.visit-table"
      // )
      //   .then((res) => {
      //     if (res.deleted) {
      //       reject("Table has been deleted.");
      //       this.scene.tableExpired(this.tableId);
      //     }
      //     else {
      //       this.tableClubId = res.clubId;
      //       resolve();
      //     }
      //   })
      //   .catch((e) => {
      //     console.error(e);
      //     reject(e);
      //   });
    });
  }
  updateTableNumber(number) {
    this.tableNumber = number;
    this.table.tableNumber = number;
  }
  getClubId() {
    return this.tableClubId;
  }
  handleVisibilityChange(hidden) {
    this.table.handleVisibilityChange(hidden);
  }

  positionControls(width, height) {
    this.table.positionControls(width, height);
    // localScaleManager.scaleSprite(
    //   this.test,
    //   width,
    //   height,
    //   0,
    //   1,
    //   true
    // );
    // this.test.setPosition(
    //   (this.tableNumber - 1) * width + (width / 2 - this.test.displayWidth / 2),
    //   this.table.y
    // );
    // WebSocketManager.getGameState(this.tableId).then(state => {
    //     // this.scene.positionsWereControlled = true;
    //     this.handleGameState(state)
    // })
    this.observeTable();
  }
  reposition(width, height) {
    this.table.reposition(width, height);
  }

  removeChildren() {
    // this.table.remove();
    // this.test.destroy();
    this.table.poolArray.forEach((obj) => {
      if (obj.children) {
        obj.destroy(true, true);
      }
      if (obj.destroy) obj.destroy(true);
    });
  }
}
